import React, { useContext, useLayoutEffect, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button from '../../../components/bootstrap/Button';
import { HeaderRight } from '../../../layout/Header/Header';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../../components/bootstrap/OffCanvas';
import Alert from '../../../components/bootstrap/Alert';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Icon from '../../../components/icon/Icon';
import ThemeContext from '../../../contexts/themeContext';
import LANG, { getLangWithKey } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import useDarkMode from '../../../hooks/useDarkMode';
import Popovers from '../../../components/bootstrap/Popovers';
import { userAuth } from '../../../contexts/userContext';
import { CartContext } from '../../../contexts/CartContext';
import CommonTimer from '../vhelper/commonTimer';
import { useLanguageSwitch } from '../../../contexts/LanguageSwitchContext';
import apiService from '../../../api/apiService';
import { usePoints } from '../../../contexts/PointsContext.js';
import './headerstlyle.css';
import { Link } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
const CommonHeaderRight = ({ beforeChildren }) => {
	const { availablePoints, pointsError, loadingPoints, fetchAvailablePoints } = usePoints();
	const { t } = useTranslation();
	const { isLangSwitchEnabled } = useLanguageSwitch();
	const { setToken, token } = useContext(userAuth);
	const {
		itemsCount,
		clearCountdown,
		notiCount,
		notiList,
		setNotiList,
		setNotiCount,
		setItemsCount,
	} = useContext(CartContext);

	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const [pendingParams, setPendingParams] = useState({
		appid: '',
	});

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	useEffect(() => {
		localStorage.setItem('theme', darkModeStatus ? 'dark' : 'light');
	}, [darkModeStatus]);

	const [offcanvasStatus, setOffcanvasStatus] = useState(false);

	const { i18n } = useTranslation();

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const u_class = '.gt_container--hich1m';

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const mobilev = windowWidth < 400 ? 'ab' : 'cd';

	useEffect(() => {
		const currentLang = getLangWithKey(i18n.language);

		if (!currentLang) {
			const langLink = document.querySelector(`.gt_option a[data-gt-lang="${LANG.EN.lng}"]`);

			if (langLink) {
				langLink.click();
				i18n.changeLanguage(LANG.EN.lng);
			}
		} else {
			const langLink = document.querySelector(
				`.gt_option a[data-gt-lang="${currentLang.lng}"]`,
			);

			if (langLink) {
				langLink.click();
				i18n.changeLanguage(currentLang.lng);
			}
		}
	}, []);

	const OnClickToCustomer = () => {
		navigate('/cart');
	};

	const changeLanguage = (lang) => {
		document.querySelectorAll(u_class + ' .gt_switcher div.gt_selected').forEach(function (e) {
			e.addEventListener('click', function (evt) {
				evt.preventDefault();
				evt.stopPropagation();
				if (gt_slider_open) gt_hide_slider();
				else gt_show_slider(e.parentNode);
			});

			e.addEventListener('pointerenter', function (evt) {
				evt.target.parentNode
					.querySelectorAll('.gt_option img:not([src])')
					.forEach(function (img) {
						img.setAttribute('src', img.getAttribute('data-gt-lazy-src'));
					});
			});

			e.dispatchEvent(new PointerEvent('pointerenter', { bubbles: true, cancelable: true }));
		});

		const langLink = document.querySelector(`.gt_option a[data-gt-lang="${lang}"]`);

		if (langLink) {
			langLink.click();
			i18n.changeLanguage(lang);

			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon={getLangWithKey(lang)?.icon} size='lg' className='me-1' />
					<span>{`Language changed to ${getLangWithKey(lang)?.text}`}</span>
				</span>,
			);
		}
	};

	const delAllNotification = async () => {
		const formData = {};

		formData['notification_id'] = 'all';

		formData['action'] = 'update_user_notification_status';
		try {
			const flechdata = await apiService(formData, token, setToken, navigate);

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setNotiList([]);
				setNotiCount([]);
			} else {
				console.log(flechdata.type);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const delNotification = async (id) => {
		const formData = {};

		formData['notification_id'] = id;

		formData['action'] = 'update_user_notification_status';
		try {
			const flechdata = await apiService(formData, token, setToken, navigate);

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setNotiCount([]);
			} else {
				console.log(flechdata.type);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});

	const navigate = useNavigate();

	const logouthandle = async () => {
		const item = { action: 'logout' };
		try {
			const flechdata = await apiService(item, token, setToken, navigate);
			if (flechdata.type === 'success') {
				setToken({});
				localStorage.removeItem('user-auth');
				setItemsCount(0);
				clearCountdown();
				navigate('/');
			} else {
				console.error('Error fetching services:', flechdata.message);
			}
		} catch (error) {
			console.error('Error fetching services:', error);
		}
	};

	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}

				<div className='col-auto'>
					<div className='col-auto position-relative'>
						<div style={{ marginTop: '10px' }}>
							<CommonTimer />
						</div>
					</div>
				</div>

				<div className='col-auto'>
					<div
						style={{
							borderRadius: '20px',
							padding: '10px 14px',
							fontSize: '14px',
							display: 'flex',
							gap: '12px',
							alignItems: 'center',
							border: '2px solid #00c6a7',
							width: 'fit-content',
							cursor: 'default',
						}}>
						<Icon icon='Redeem' size='lg' color='#00c6a7' />
						<span style={{ fontWeight: 'bold' }}>{`${availablePoints ?? 0} PTS`}</span>
					</div>
				</div>

				<div className='col-auto'>
					<div className='col-auto position-relative'>
						{/* <Popovers trigger='hover' desc='Cart'> */}
						<Button {...styledBtn} icon='Cart' onClick={OnClickToCustomer} />
						{/* </Popovers> */}
						{(itemsCount || itemsCount !== 0) && (
							<span className='position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger'>
								{itemsCount < 99 ? itemsCount : '99+'}
							</span>
						)}
					</div>
				</div>

				<div className='col-auto'>
					{/* <Popovers trigger='hover' desc='Dark / Light mode'> */}
					<Button
						{...styledBtn}
						icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
						onClick={() => setDarkModeStatus((prev) => !prev)}
						data-tour='dark-mode'
					/>
					{/* </Popovers> */}
				</div>

				{isLangSwitchEnabled && (
					// <Popovers trigger='hover' desc='Change Language'>
					<div className='col-auto'>
						<Dropdown>
							<DropdownToggle hasIcon={false}>
								<Button
									{...styledBtn}
									icon={getLangWithKey(i18n.language)?.icon}
									data-tour='lang-selector'
								/>
							</DropdownToggle>
							<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
								{Object.keys(LANG).map((key) => (
									<DropdownItem key={LANG[key].lng}>
										<Button
											icon={LANG[key].icon}
											onClick={() => changeLanguage(LANG[key].lng)}>
											{LANG[key].text}
										</Button>
									</DropdownItem>
								))}
							</DropdownMenu>
						</Dropdown>
					</div>
					// </Popovers>
				)}

				{/*	Notifications */}
				<div className='col-auto'>
					<div className='col-auto position-relative'>
						<Button
							{...styledBtn}
							icon='Notifications'
							onClick={() => setOffcanvasStatus(true)}
							aria-label='Notifications'
						/>
						{/* {(notiCount || notiCount !== 0) && (
							<span className='position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger'>
								{notiCount < 99 ? notiCount : '99+'}
							</span>
						)} */}
						{notiCount > 0 && (
    <span className='position-absolute top-0 start-90 translate-middle badge rounded-pill bg-danger'>
        {notiCount < 99 ? notiCount : '99+'}
    </span>
)}
					</div>
				</div>

				<div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							{/* eslint-disable-next-line react/jsx-props-no-spreading */}
							<Button {...styledBtn} icon='Person' aria-label='Quick menu' />
						</DropdownToggle>
						<DropdownMenu
							isAlignmentEnd
							size={windowWidth < 740 ? 'sm' : 'lg'}
							className='py-0 overflow-hidden'>
							<div className='row g-0'>
								<div
									className={classNames(
										'col-12',
										'p-4',
										'd-flex justify-content-center',
										'fw-medium fs-5',
										'text-info',
										'border-bottom border-info',
										'bg-lo25-info',
									)}>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
										}}>
										<span style={{ color: 'white', fontSize: '16px' }}>
											{token.name}
										</span>
										<span style={{ color: 'white', fontSize: '12px' }}>
											{token.email}
										</span>
									</div>
								</div>
								<div
									className={classNames(
										'col-12 p-4 transition-base cursor-pointer',
										// 'border-end border-bottom',
										{ 'border-dark': darkModeStatus },
									)}>
									<div
										className='d-flex flex-column align-items-center justify-content-center'
										onClick={logouthandle}>
										{/* <Icon icon='Logout' size='3x' color='info' onClick={() => logout()}/> */}
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: '10px',
												color: '#e17f7f',
											}}>
											<Icon icon='Logout' size='3x' />
											<span style={{ fontWeight: '500', fontSize: '14px' }}>
												{t('Log Out')}
											</span>
										</div>
									</div>
								</div>
							</div>
						</DropdownMenu>
					</Dropdown>
				</div>

				<div className='col-auto'>
					{/* <Popovers trigger='hover' desc={t('Fullscreen')}> */}
					<Button
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...styledBtn}
						icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
						onClick={() => setFullScreenStatus(!fullScreenStatus)}
						aria-label='Toggle dark mode'
					/>
					{/* </Popovers> */}
				</div>
			</div>

			<OffCanvas
				id='notificationCanvas'
				titleId='offcanvasExampleLabel'
				placement='end'
				isOpen={offcanvasStatus}
				setOpen={setOffcanvasStatus}>
				<OffCanvasHeader setOpen={setOffcanvasStatus}>
					<OffCanvasTitle id='offcanvasExampleLabel'>Notifications</OffCanvasTitle>
					{notiList.length > 0 && (
						<Button
							color='danger'
							icon='Delete'
							style={{ marginLeft: '100px' }}
							onClick={
								() => delAllNotification()
								//setNotiList([])
							}>
							Clear All
						</Button>
					)}
				</OffCanvasHeader>
				<OffCanvasBody>

					<div className='notifications-body'>
						{notiList && notiList.length > 0 ? (
							notiList.map((item) => {
								let pathname = '';
								switch (item.notify_type) {
									case 'add_appointment':
										pathname = '/appointment/pending';
										break;
									case 'cancel_appointment':
										pathname = '/appointment/cancelled';
										break;
									case 'complete_appointment':
										pathname = '/appointment/completed';
										break;
									default:
										pathname = '/';
								}

								return (
									<Alert
										icon='NotificationsNone'
										isLight
										color='info'
										className='flex-nowrap'
										isDismissible
										onClose={() => delNotification(item.id)}>
										
										<div
											onClick={() => {
												navigate(
													`${pathname}?appid=${item.appointment_code}`,
												);
												setOffcanvasStatus(false);
												setPendingParams(item.appointment_code);
											}}>
											<strong>{item.notify_title}</strong>
											<p>{item.notify_full_desc}</p>
											<small
												style={{
													marginLeft: mobilev == 'ab' ? '110px' : '150px',
												}}>
												{item.created_at}
											</small>
										</div>
									</Alert>
								);
							})
						) : (
							<p style={{ marginTop: '120px', marginLeft: '135px' }}>
								No notifications
							</p>
						)}
					</div>
					{/* <Alert icon='ViewInAr' isLight color='info' className='flex-nowrap'>
						4 new components added.
					</Alert>
					<Alert icon='ThumbUp' isLight color='warning' className='flex-nowrap'>
						New products added to stock.
					</Alert>
					<Alert icon='Inventory2' isLight color='danger' className='flex-nowrap'>
						There are products that need to be packaged.
					</Alert>
					<Alert icon='BakeryDining' isLight color='success' className='flex-nowrap'>
						Your food order is waiting for you at the consultation.
					</Alert>
					<Alert icon='Escalator' isLight color='primary' className='flex-nowrap'>
						Escalator will turn off at 6:00 pm.
					</Alert> */}
				</OffCanvasBody>
			</OffCanvas>
		</HeaderRight>
	);
};
CommonHeaderRight.propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

export default CommonHeaderRight;
